import { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import IndiaPayment from '../../components/Payment/IndiaPayment';
import CryptoJS from 'crypto-js';
import '../../styles/global.scss';
const Payment = () => {
  const { paymentData, setPaymentData } = useStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment_id = params.get('payment_id');
    const encryptedPayload = params.get('p');
    if (!payment_id || !encryptedPayload) {
      console.log('Missinf data');
      return;
    }
    console.log('payment_id ', payment_id);
    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedPayload,
        process.env.REACT_APP_SECRET_KEY
      );
      const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
      const data = JSON.parse(decryptedStr);
      setPaymentData({ ...data, order_id: payment_id });
      console.log('Decrypted payload:', data);
    } catch (error) {
      console.error('Failed to decrypt window.name payload', error);
    }
  }, []);

  useEffect(() => {
    console.log('Country', paymentData.country);
  }, [paymentData]);
  return (
    <div className="bg-white" style={{ width: '100%', position: 'relative' }}>
      <Header /> {paymentData.country === 'IND' && <IndiaPayment />}
    </div>
  );
};

export default Payment;
